import { FAQ_URL, USER_TERM_URL, VARIOUS_POLICY_GUIDE_URL } from 'common/utils';

interface PolicyTextType {
  className?: string;
}

const PolicyText = ({ className }: PolicyTextType) => {
  return (
    <div
      className={`text-xs font-normal leading-relaxed text-pp-text-secondary ${className || ''}`}
    >
      投稿時、
      <a
        href={USER_TERM_URL}
        target="_blank"
        rel="noopener"
        className="text-pp-text-primary underline transition-colors hover:text-pp-text-secondary"
      >
        利用規約
      </a>
      及び
      <a
        href={VARIOUS_POLICY_GUIDE_URL}
        target="_blank"
        rel="noopener"
        className="text-pp-text-primary underline transition-colors hover:text-pp-text-secondary"
      >
        各種ポリシー
      </a>
      に同意したものとみなします。法令違反および第三者の権利侵害に配慮した投稿をお願いいたします。著作権に関する
      <a
        href={FAQ_URL}
        target="_blank"
        rel="noopener"
        className="text-pp-text-primary underline transition-colors hover:text-pp-text-secondary"
      >
        FAQ
      </a>
      もご確認ください。投稿作成については、
      <a
        href="https://help.postprime.com/hc/ja/articles/4411353825039"
        target="_blank"
        rel="noopener"
        className="text-pp-text-primary underline transition-colors hover:text-pp-text-secondary"
      >
        こちら
      </a>
      をご確認ください。
    </div>
  );
};

export default PolicyText;
